module.exports = __webpack_public_path__ + "img/bar_bg.09c03340.jpg";